module.exports = __webpack_public_path__ + "img/629.0638fbe1.jpg";